import { Card } from "@mui/material";
import SoftButton from "components/SoftButton";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { api } from "utils/Api";
import DetailBox from "utils/Detail-Box/DetailBox";
import Tickets from "./Tickets/Tickets";
import ShiftNotes from "./ShiftNotes/ShiftNotes";
import { useHierarchy } from "context/HierarchyContext";

function UnitDetail() {
  const { orgCode, propertyCode, unitCode, unitDetailTab } = useParams();
  const navigate = useNavigate();
  const { unitId, isHierarchyReady } = useHierarchy();

  const [unitData, setUnitData] = useState({});
  const activeTab = unitDetailTab || "tickets";

  // ✅ Redirect to default tab if not present
  useEffect(() => {
    if (!unitDetailTab) {
      navigate(
        `/super-admin/organization/${orgCode}/properties/${propertyCode}/unit/${unitCode}/tickets`,
        { replace: true }
      );
    }
  }, [unitDetailTab, navigate]);

  // ✅ Fetch Unit Details
  const fetchUnitDetails = async () => {
    try {
      const response = await api.su_unit.getSuUnitDetails(unitId);
      setUnitData(response);
    } catch (error) {
      Swal.fire({
        title: "Failed to fetch unit details",
        icon: "error",
        toast: true,
        timer: 2000,
        position: "bottom-right",
        showConfirmButton: false,
      });
    }
  };

  useEffect(() => {
    if (unitId) {
      fetchUnitDetails();
    }
  }, [unitId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* Unit Information */}
        <DetailBox
        title={ `${unitData?.name} (${unitData?.unit_code})` || "Unit Details"}
          data={unitData}
          inputs={[
            // { label: "Unit Name", key: "name" },
            // { label: "Unit Code", key: "unit_code" },
            { label: "Floor", key: "floor" },
          ]}
        />
      {/* Tabs */}
      <Card
        sx={{
          display: "flex",
          flexDirection: "row",
          mb: 1,
          p: 1,
          background: "#f5f7fa",
          borderRadius: "10px",
          width: "fit-content",
        }}
      >
        {/* Tickets */}
        <SoftButton
          onClick={() =>
            navigate(`/super-admin/organization/${orgCode}/properties/${propertyCode}/unit/${unitCode}/tickets`)}
          size="small"
          sx={{
            px: 3,
            borderRadius: "8px",
            fontWeight: 600,
            backgroundColor:
              activeTab === "tickets" ? "#e3f2fd" : "#ffffff",
            color: activeTab === "tickets" ? "#03a9f4" : "#9e9e9e",
            border: "2px solid",
            borderColor:
              activeTab === "tickets" ? "#b3e5fc" : "#e0e0e0",
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            boxShadow:
              activeTab === "tickets"
                ? "0 2px 6px rgba(3,169,244,0.15)"
                : "none",
            "&:hover": {
              backgroundColor:
                activeTab === "tickets" ? "#e1f5fe" : "#fafafa",
            },
          }}
        >
          Tickets
        </SoftButton>

        {/* Shift Notes */}
        <SoftButton
          onClick={() =>
            navigate(`/super-admin/organization/${orgCode}/properties/${propertyCode}/unit/${unitCode}/shift-notes`)}
          size="small"
          sx={{
            px: 3,
            ml: 1,
            borderRadius: "8px",
            fontWeight: 600,
            backgroundColor:
              activeTab === "shift-notes" ? "#e3f2fd" : "#ffffff",
            color:
              activeTab === "shift-notes" ? "#03a9f4" : "#9e9e9e",
            border: "2px solid",
            borderColor:
              activeTab === "shift-notes"
                ? "#b3e5fc"
                : "#e0e0e0",
            borderBottom: "none",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            boxShadow:
              activeTab === "shift-notes"
                ? "0 2px 6px rgba(3,169,244,0.15)"
                : "none",
            "&:hover": {
              backgroundColor:
                activeTab === "shift-notes"
                  ? "#e1f5fe"
                  : "#fafafa",
            },
          }}
        >
          Shift Notes
        </SoftButton>
      </Card>

      {/* Tab Content */}
      {activeTab === "tickets" && <Tickets />}
      {activeTab === "shift-notes" && <ShiftNotes />}

      <Footer />
    </DashboardLayout>
  );
}

export default UnitDetail;
